import { sha3_256 } from "js-sha3";
import JSEncrypt from "jsencrypt";

const PUBLIC_KEY = `-----BEGIN RSA PUBLIC KEY-----
MIGJAoGBAJaD3TRsNxKpXMXF/VNniLCeC023A8baWN8KSs/75vHYdJSKFnAoaMzQ
OE3a1RZtoWg5U+N6VGo2y8p7jQNlu+vgGYsqYUtssY+fCOQ+/8xRoAQe6JcnhQsC
xLCqqzKPJ2JhTuWZijBgDHvH6a66hU0lPLTLnN7lf7Yn6HZwz7mFAgMBAAE=
-----END RSA PUBLIC KEY-----`;

const calculateSHA3Encryption = (data: object): string => {
  // 将对象转换为字符串
  const dataString = JSON.stringify(data);
  const encoder = new TextEncoder();
  const encodedData = encoder.encode(dataString);
  const digest = sha3_256(encodedData);
  const encryption_data = encryption(digest);
  return encodeURIComponent(encryption_data);
};

const calculateSHA3EncryptionWithParams = (url: string, params: Record<string, string>): string => {
  url = "https://xx" + url;
  const urlObject = new URL(url);
  const searchParams = new URLSearchParams(urlObject.search);

  // 将参数添加到URL的查询字符串中
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      searchParams.set(key, params[key]);
    }
  }

  // 获取编码后的查询字符串
  const encodedQueryString = searchParams.toString();

  // 构建待摘要验证的数据
  let dataToHash = encodedQueryString;
  dataToHash = decodeURIComponent(decodeURIComponent(dataToHash));
  // 将数据编码为 Uint8Array
  const encoder = new TextEncoder();
  const encodedData = encoder.encode(dataToHash);
  const digest = sha3_256(encodedData);

  const encryption_data = encryption(digest);
  return encodeURIComponent(encryption_data);
};

const encryption = (data: string): any => {
  const encryptor = new JSEncrypt();
  const pubKey = PUBLIC_KEY;
  encryptor.setPublicKey(pubKey);
  const rsaPassWord = encryptor.encrypt(pad(data));
  return rsaPassWord;
};

const pad = (s: string): string => {
  const blockSize = 16;
  const padding = blockSize - (s.length % blockSize);
  return s + String.fromCharCode(padding).repeat(padding);
};

export { calculateSHA3Encryption, calculateSHA3EncryptionWithParams };
